import styled from "styled-components";

export const ToolbarControls = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 4rem;
`;
